<script lang="ts">
  // Non-interactive card image (small or full-res) with a styled text-frame
  // fallback for passcodes the CDN lacks. Used for list-row thumbs + the large
  // hover preview; CardTile (the clickable card) is separate.
  import type { CardInfo } from "@ygoevo/yo2-data";
  import { cardImage, cardImageLarge } from "../../data.ts";
  import { frameColor } from "../cards.ts";

  let {
    card,
    large = false,
    class: cls = "",
  }: { card: CardInfo; large?: boolean; class?: string } = $props();

  let broken = $state(false);
  // Reset the error state when the card changes (e.g. the shared large preview).
  $effect(() => {
    void card.id;
    broken = false;
  });

  const fmt = (v: number | null) => (v === null ? "" : v === -2 ? "?" : String(v));
</script>

<div class="relative aspect-[59/86] overflow-hidden chamfer-btn {cls}" style="--c:4px">
  {#if !broken}
    <img
      src={large ? cardImageLarge(card.id) : cardImage(card.id)}
      alt={card.name}
      onerror={() => (broken = true)}
      class="size-full object-cover"
      draggable="false"
    />
  {:else}
    <div class="flex size-full flex-col" style="background:{frameColor(card)}">
      <div class="truncate px-1 pt-1 text-center font-bold leading-tight text-white/95 {large ? 'text-sm' : 'text-[0.5rem]'}" style="text-shadow:0 1px 1px rgba(0,0,0,.6)">
        {card.name}
      </div>
      <div class="m-1 flex-1 bg-black/25"></div>
      {#if card.category === "monster" || card.category === "monster-extra"}
        <div class="px-1 pb-1 text-right font-bold tabular-nums text-white/95 {large ? 'text-xs' : 'text-[0.5rem]'}" style="text-shadow:0 1px 1px rgba(0,0,0,.6)">
          {fmt(card.atk)}{card.def !== null ? `/${fmt(card.def)}` : ""}
        </div>
      {:else}
        <div class="px-1 pb-1 text-center uppercase tracking-wide text-white/90 {large ? 'text-xs' : 'text-[0.5rem]'}">{card.category}</div>
      {/if}
    </div>
  {/if}
</div>
